import { IntlShape } from 'react-intl'

// ─── Intl instance store ──────────────────────────────────────────────────────
// Holds the live react-intl instance so the String prototype method can reach
// it outside of React components. Updated whenever the locale changes.

let _intl: IntlShape | null = null

export const setIntlInstance = (intl: IntlShape): void => {
  _intl = intl
}

// ─── String.prototype.toTranslatedDisplay() ───────────────────────────────────
//
// Uses the English string itself as the message ID (gettext-style).
// Falls back to the original string when:
//   • the intl instance isn't ready yet (pre-mount)
//   • no translation entry exists for this string
//
// Usage:
//   'Create Contact'.toTranslatedDisplay()          // → "Kontakt erstellen" (de)
//   `Hello ${name}`.toTranslatedDisplay()           // dynamic strings fall back
//
// Translation files — add the English string as the key:
//   de.json: { "Create Contact": "Kontakt erstellen" }
//   es.json: { "Create Contact": "Crear contacto" }

declare global {
  interface String {
    toTranslatedDisplay(): string
  }
}

String.prototype.toTranslatedDisplay = function (): string {
  const str = String(this)
  if (!_intl || !str) return str

  // formatMessage returns the defaultMessage when the ID has no catalog entry,
  // so this is always safe to call even for strings not yet translated.
  return _intl.formatMessage(
    { id: str, defaultMessage: str } as Parameters<IntlShape['formatMessage']>[0]
  )
}
